/**
 * Formats size unit and gender for display without any casing transforms.
 * Returns base format like "US Men's" or "JP Women's" or just "US"
 * Use CSS text-transform for uppercase as needed in the UI
 *
 * Examples:
 * - formatSizeLabel('US', 'men') => "US Men's"
 * - formatSizeLabel('JP', 'women') => "JP Women's"
 * - formatSizeLabel('US') => "US"
 */
export const formatSizeLabel = (sizeUnit?: string, gender?: string): string => {
  const unit = sizeUnit?.toUpperCase() || 'US'

  if (!gender) return unit

  const lowerGender = gender.toLowerCase()
  if (lowerGender === 'men') {
    return `${unit} Men's`
  }
  if (lowerGender === 'women') {
    return `${unit} Women's`
  }

  // Fallback for any other gender value
  const formatted = gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase()
  return `${unit} ${formatted}`
}
